(function () {
  "use strict";

  var root = document.querySelector("[data-supplier-dashboard]");
  var cfg = window.BBSupplierDashboard || {};
  var thumbnails = window.BBSupplierThumbnails || {};
  var productionFileModel = window.BBSupplierProductionFiles || {};
  var workflowModel = window.BBSupplierWorkflowModel || {};
  var trackingCarriers = window.BBTrackingCarriers || {};
  var dashboardTime = window.BBDashboardTime || {};
  if (!root || (!cfg.loggedIn && !root.classList.contains("is-preview")))
    return;

  var strings = cfg.strings || {};
  var workspace = root.querySelector(".bb-supplier__workspace");
  var queueRoot = root.querySelector("[data-supplier-queue]");
  var listRoot = root.querySelector("[data-supplier-list]");
  var detailRoot = root.querySelector("[data-supplier-detail]");
  var detailContent = root.querySelector("[data-supplier-detail-content]");
  var search = root.querySelector("[data-supplier-search]");
  var status = root.querySelector("[data-supplier-status]");
  var urgency = root.querySelector("[data-supplier-urgency]");
  var sort = root.querySelector("[data-supplier-sort]");
  var clearFilters = root.querySelector("[data-supplier-clear]");
  var filterToggle = root.querySelector("[data-supplier-filter-toggle]");
  var filterPanel = root.querySelector("[data-supplier-filter-panel]");
  var filterCount = root.querySelector("[data-supplier-filter-count]");
  var refreshButton = root.querySelector("[data-supplier-refresh]");
  var lastUpdated = root.querySelector("[data-supplier-last-updated]");
  var paginationRoot = root.querySelector("[data-supplier-pagination]");
  var pageSummary = root.querySelector("[data-supplier-page-summary]");
  var pageSizeControl = root.querySelector("[data-supplier-page-size]");
  var previousPage = root.querySelector("[data-supplier-page-prev]");
  var nextPage = root.querySelector("[data-supplier-page-next]");
  var count = root.querySelector("[data-supplier-result-count]");
  var statusMessage = root.querySelector("[data-supplier-status-message]");
  var noticeRoot = root.querySelector("[data-supplier-notifications]");
  var backButton = root.querySelector("[data-supplier-back]");
  var dialog = root.querySelector("[data-supplier-dialog]");
  var form = root.querySelector("[data-supplier-action-form]");
  var dialogKicker = root.querySelector("[data-supplier-dialog-kicker]");
  var dialogTitle = root.querySelector("[data-supplier-dialog-title]");
  var dialogDescription = root.querySelector(
    "[data-supplier-dialog-description]",
  );
  var dialogContext = root.querySelector("[data-supplier-dialog-context]");
  var dialogFields = root.querySelector("[data-supplier-dialog-fields]");
  var dialogError = root.querySelector("[data-supplier-dialog-error]");
  var dialogProgress = root.querySelector("[data-supplier-dialog-progress]");
  var submit = root.querySelector("[data-supplier-dialog-submit]");
  var mobileQuery = window.matchMedia("(max-width: 960px)");
  var POLL_INTERVAL = 60000;
  var isPreview = root.classList.contains("is-preview");
  var previewState =
    new URLSearchParams(window.location.search).get(
      "bb_supplier_preview_state",
    ) || "default";
  var orders = [];
  var notifications = [];
  var selectedId = "";
  var currentOrder = null;
  var pendingAction = "";
  var dialogBusy = false;
  var activeBucket = "action";
  var page = 1;
  var pageSize = 25;
  var pagination = { page: 1, page_size: 25, total: 0, page_count: 1 };
  var queueCounts = {
    action: 0,
    progress: 0,
    waiting: 0,
    history: 0,
    overdue: 0,
    due_soon: 0,
  };
  var statusFacets = [];
  var generatedAt = "";
  var supplierTimeZone = "UTC";
  var searchTimer = 0;
  var requestController = null;
  var detailRequestController = null;
  var detailRequestPromise = null;
  var detailRequestId = "";
  var detailRequestToken = 0;
  var listRequestToken = 0;
  var listCache = Object.create(null);
  var detailCache = Object.create(null);
  var lastDialogTrigger = null;
  var OFFICE_HANDOFFS = {
    c2r_miami: {
      key: "c2r_miami",
      display_name: "BadgeBuzz Fulfillment Center — Miami",
      company_name: "Choose 2 Rent Inc.",
      attention: "0 Branding",
      address1: "675 NW 97th Street",
      address2: "",
      city: "Miami",
      province_code: "FL",
      postal_code: "33150",
      country_code: "USA",
      phone: "+1 800 6226484",
    },
    c2r_las_vegas: {
      key: "c2r_las_vegas",
      display_name: "BadgeBuzz Fulfillment Center — Las Vegas",
      company_name: "Choose 2 Rent Inc.",
      attention: "0 Branding",
      address1: "4330 S Valley View Blvd",
      address2: "Suite 128",
      city: "Las Vegas",
      province_code: "NV",
      postal_code: "89103",
      country_code: "USA",
      phone: "+1 800 6226484",
    },
  };

  function esc(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function label(value) {
    return String(value || "")
      .replace(/_/g, " ")
      .replace(/\b\w/g, function (letter) {
        return letter.toUpperCase();
      });
  }

  function date(value) {
    if (!value) return strings.notScheduled || "Not scheduled";
    return dashboardTime.format
      ? dashboardTime.format(value, { timeZone: supplierTimeZone })
      : String(value);
  }

  function dateTime(value) {
    if (!value) return "";
    return dashboardTime.format
      ? dashboardTime.format(value, {
          timeZone: supplierTimeZone,
          includeTime: true,
        })
      : String(value);
  }

  function money(value, currency) {
    if (value == null || !currency) return strings.notSet || "Not set";
    if (window.BadgeBuzzMoney) {
      return window.BadgeBuzzMoney.format(value, {
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency,
      }).format(Number(value));
    } catch (error) {
      return currency + " " + Number(value).toFixed(2);
    }
  }

  function idempotencyKey() {
    return window.crypto && window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : Date.now() + "-" + Math.random().toString(16).slice(2);
  }

  function clearNavigationCache(orderId) {
    listCache = Object.create(null);
    if (orderId) delete detailCache[orderId];
  }

  function requestJson(url, options) {
    return fetch(url, options).then(function (response) {
      return response
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          if (!response.ok) {
            var error = new Error(data.error || strings.requestFailed);
            error.status = response.status;
            throw error;
          }
          return data;
        });
    });
  }

  function announce(message) {
    if (!statusMessage) return;
    statusMessage.textContent = "";
    window.setTimeout(function () {
      statusMessage.textContent = message;
    }, 20);
  }

  function isDueSoon(order) {
    return order.urgency === "due_soon" || order.urgency === "overdue";
  }

  function stateLabel(value) {
    var labels = {
      awaiting_production_files: strings.preparingFiles,
      awaiting_supplier: strings.readyReview,
      preflight: strings.preflight,
      awaiting_customer_approval: strings.waitingCustomer,
      revision_requested: strings.revisionRequested,
      approved_for_production: strings.approvedForProduction,
      in_production: strings.inProduction,
      quality_check: strings.qualityCheck,
      ready_to_ship: strings.readyToShip,
      fulfillment_pending: strings.fulfillmentPending,
      handed_off_to_office: strings.handedOffToOffice,
      completed: strings.completed,
      superseded: strings.superseded,
      declined: strings.declined,
    };
    return labels[value] || label(value);
  }

  function orderDisplayState(order) {
    return (
      typeof workflowModel.displayStateForBucket === "function"
        ? workflowModel.displayStateForBucket(order, activeBucket)
        : typeof workflowModel.displayStateForOrder === "function"
          ? workflowModel.displayStateForOrder(order)
          : order.state
    );
  }

  function orderStateLabel(order) {
    var customerStatus = String(order.customer_status || "").toLowerCase();
    if (order.state === "completed" && customerStatus === "delivered")
      return strings.delivered;
    if (order.state === "completed" && customerStatus === "out for delivery")
      return strings.outForDelivery;
    return stateLabel(orderDisplayState(order));
  }

  function statusBadgeTone(state) {
    var tones = {
      awaiting_supplier: "action",
      preflight: "action",
      revision_requested: "action",
      approved_for_production: "action",
      ready_to_ship: "action",
      in_production: "info",
      quality_check: "info",
      awaiting_customer_approval: "waiting",
      customer_review: "waiting",
      fulfillment_pending: "waiting",
      completed: "success",
      handed_off_to_office: "success",
      approved: "success",
      declined: "danger",
      rejected: "danger",
    };
    return typeof tones[state] === "string" ? tones[state] : "neutral";
  }

  function statusBadgeHtml(state, text) {
    return '<span class="bb-supplier__badge bb-supplier__badge--' +
      statusBadgeTone(state) + '">' + esc(text) + "</span>";
  }

  function orderStatusBadgeHtml(order) {
    return statusBadgeHtml(orderDisplayState(order), orderStateLabel(order));
  }

  function responsibleLabel(order) {
    if (
      typeof workflowModel.displayStateForOrder === "function" &&
      workflowModel.displayStateForOrder(order) === "awaiting_customer_approval"
    )
      return "";
    if (order.responsible_party === "customer") return "";
    if (order.responsible_party === "staff") return strings.staffReview;
    if ((order.allowed_actions || []).length) return strings.yourAction;
    return strings.progress;
  }

  function previewOrders() {
    return [
      {
        id: "preview-1",
        shopify_order_gid: "gid://shopify/Order/1",
        shopify_order_name: "#BB-52947",
        state: "awaiting_supplier",
        version: 3,
        responsible_party: "supplier",
        requested_in_hand_date: "2026-08-12",
        supplier_due_date: "2026-07-23",
        urgency: "due_soon",
        shipping_mode: "direct",
        po_currency: "USD",
        po_subtotal: 215,
        po_adjustments: [{ label: "Rush handling", amount: 25 }],
        po_total: 240,
        delivery: {
          recipient_name: "Alex Morgan",
          company: "Aperture Events",
          address1: "100 Market Street",
          address2: "Suite 400",
          city: "Miami",
          province_code: "FL",
          postal_code: "33101",
          country_code: "US",
          phone: "+1 305 555 0100",
        },
        allowed_actions: ["start_production", "decline"],
        lines: [
          {
            title: "Tear-resistant event badges",
            variant_title: "Full color",
            sku: "TRB-100",
            quantity: 100,
            custom_attributes: [
              { key: "Badge size", value: "4 × 6 in" },
              { key: "Finish", value: "Matte" },
              {
                key: "Design Preview Back",
                value: cfg.productPlaceholderUrl,
              },
            ],
            zakeke_preview_url: "#preview-artwork",
            zakeke_preview_back_url: cfg.productPlaceholderUrl,
          },
          {
            title: "Badge lanyards",
            variant_title: "Navy",
            sku: "LAN-NVY",
            quantity: 100,
            custom_attributes: [],
          },
        ],
        production_files: [
          {
            id: "production-1",
            file_type: "PDF",
            modification_id: "ART-52947",
          },
        ],
        files: [],
        proofs: [],
        events: [
          {
            action: "production_files_ready",
            actor_type: "system",
            created_at: "2026-07-19T07:20:00Z",
          },
          {
            action: "supplier_assigned",
            actor_type: "staff",
            created_at: "2026-07-18T08:00:00Z",
          },
        ],
      },
      {
        id: "preview-2",
        shopify_order_gid: "gid://shopify/Order/2",
        shopify_order_name: "#BB-52931",
        state: "in_production",
        version: 5,
        responsible_party: "supplier",
        requested_in_hand_date: "2026-08-20",
        supplier_due_date: "2026-08-13",
        urgency: "normal",
        shipping_mode: "office_handoff",
        handoff_office: "Miami",
        po_currency: "USD",
        po_subtotal: 680,
        po_adjustments: [],
        po_total: 680,
        delivery: { office: "Miami" },
        allowed_actions: ["submit_fulfillment"],
        lines: [
          {
            title: "Reusable conference passes",
            variant_title: "Double-sided",
            sku: "RCP-DS",
            quantity: 250,
            custom_attributes: [{ key: "Size", value: "3.5 × 5.5 in" }],
          },
        ],
        production_files: [
          {
            id: "production-2",
            file_type: "PDF",
            modification_id: "ART-52931",
          },
        ],
        files: [],
        proofs: [],
        events: [
          {
            action: "production_started",
            actor_type: "supplier",
            created_at: "2026-07-18T11:40:00Z",
          },
          {
            action: "production_files_ready",
            actor_type: "system",
            created_at: "2026-07-17T15:20:00Z",
          },
        ],
      },
      {
        id: "preview-3",
        shopify_order_gid: "gid://shopify/Order/3",
        shopify_order_name: "#BB-52888",
        state: "awaiting_customer_approval",
        version: 4,
        responsible_party: "customer",
        requested_in_hand_date: "2026-08-09",
        supplier_due_date: "2026-07-17",
        urgency: "overdue",
        shipping_mode: "direct",
        po_currency: "USD",
        po_subtotal: 395,
        po_adjustments: [],
        po_total: 395,
        delivery: {
          recipient_name: "Jamie Chen",
          company: "Northstar Summit",
          address1: "88 Howard Street",
          city: "San Francisco",
          province_code: "CA",
          postal_code: "94105",
          country_code: "US",
        },
        allowed_actions: [],
        lines: [
          {
            title: "VIP holographic badges",
            variant_title: "Silver foil",
            sku: "VIP-HOLO",
            quantity: 75,
            custom_attributes: [],
          },
        ],
        production_files: [],
        files: [],
        proofs: [
          {
            version: 1,
            status: "customer_review",
            customer_feedback: "",
            files: [
              {
                id: "proof-1",
                name: "northstar-vip-proof.pdf",
                media_type: "application/pdf",
              },
            ],
          },
        ],
        events: [
          {
            action: "proof_submitted",
            actor_type: "supplier",
            created_at: "2026-07-18T13:10:00Z",
          },
          {
            action: "supplier_assigned",
            actor_type: "staff",
            created_at: "2026-07-16T09:00:00Z",
          },
        ],
      },
      {
        id: "preview-4",
        shopify_order_gid: "gid://shopify/Order/4",
        shopify_order_name: "#BB-52762",
        state: "completed",
        version: 8,
        responsible_party: "staff",
        requested_in_hand_date: "2026-07-18",
        supplier_due_date: "2026-07-12",
        urgency: "normal",
        shipping_mode: "direct",
        po_currency: "USD",
        po_subtotal: 310,
        po_adjustments: [],
        po_total: 310,
        delivery: {
          recipient_name: "Taylor Reed",
          company: "Fieldwork Expo",
          address1: "400 Pine Avenue",
          city: "Seattle",
          province_code: "WA",
          postal_code: "98101",
          country_code: "US",
        },
        allowed_actions: [],
        tracking_number: "1Z999AA10123456784",
        tracking_company: "UPS",
        tracking_url: "#preview-tracking",
        invoice_disposition: "uploaded",
        lines: [
          {
            title: "Exhibitor badge packs",
            variant_title: "Variable data",
            sku: "EXB-VD",
            quantity: 150,
            custom_attributes: [],
          },
        ],
        production_files: [],
        files: [
          {
            id: "invoice-1",
            name: "invoice-BB-52762.pdf",
            media_type: "application/pdf",
          },
        ],
        proofs: [],
        events: [
          {
            action: "order_completed",
            actor_type: "staff",
            created_at: "2026-07-14T17:30:00Z",
          },
          {
            action: "fulfillment_submitted",
            actor_type: "supplier",
            created_at: "2026-07-13T14:15:00Z",
          },
        ],
      },
      {
        id: "preview-5",
        shopify_order_gid: "gid://shopify/Order/5",
        shopify_order_name: "#BB-52952",
        state: "revision_requested",
        version: 6,
        responsible_party: "supplier",
        requested_in_hand_date: "2026-08-07",
        supplier_due_date: "2026-07-18",
        urgency: "overdue",
        shipping_mode: "direct",
        po_currency: "USD",
        po_subtotal: 525,
        po_adjustments: [{ label: "Color match", amount: 35 }],
        po_total: 560,
        delivery: {
          recipient_name: "Morgan Davis",
          company: "Helix Labs",
          address1: "12 Innovation Way",
          city: "Austin",
          province_code: "TX",
          postal_code: "78701",
          country_code: "US",
        },
        allowed_actions: ["submit_proof", "decline"],
        lines: [
          {
            title: "Employee credential cards",
            variant_title: "Pantone matched",
            sku: "ECC-PMS",
            quantity: 200,
            custom_attributes: [],
          },
        ],
        production_files: [],
        files: [],
        proofs: [
          {
            version: 1,
            status: "revision_requested",
            customer_feedback:
              "Please move the department name below the photo.",
            files: [
              {
                id: "proof-2",
                name: "helix-credential-v1.pdf",
                media_type: "application/pdf",
              },
            ],
          },
        ],
        events: [
          {
            action: "revision_requested",
            actor_type: "customer",
            reason: "Please move the department name below the photo.",
            created_at: "2026-07-19T06:45:00Z",
          },
          {
            action: "proof_submitted",
            actor_type: "supplier",
            created_at: "2026-07-18T10:00:00Z",
          },
        ],
      },
      {
        id: "preview-6",
        shopify_order_gid: "gid://shopify/Order/6",
        shopify_order_name: "#BB-52904",
        state: "in_production",
        version: 7,
        responsible_party: "supplier",
        requested_in_hand_date: "2026-07-29",
        supplier_due_date: "2026-07-24",
        urgency: "due_soon",
        shipping_mode: "direct",
        po_currency: "USD",
        po_subtotal: 185,
        po_adjustments: [],
        po_total: 185,
        delivery: {
          recipient_name: "Riley Patel",
          company: "Civic Forum",
          address1: "205 King Street",
          city: "Boston",
          province_code: "MA",
          postal_code: "02110",
          country_code: "US",
        },
        allowed_actions: ["submit_fulfillment"],
        lines: [
          {
            title: "Speaker badges",
            variant_title: "Soft touch",
            sku: "SPK-ST",
            quantity: 50,
            custom_attributes: [],
          },
        ],
        production_files: [
          {
            id: "production-6",
            file_type: "PDF",
            modification_id: "ART-52904",
          },
        ],
        files: [],
        proofs: [],
        events: [
          {
            action: "production_started",
            actor_type: "supplier",
            created_at: "2026-07-17T12:00:00Z",
          },
        ],
      },
    ];
  }

  function bucketFor(order) {
    if (typeof workflowModel.supplierBucketForState === "function")
      return workflowModel.supplierBucketForState(order.state);
    if (
      [
        "completed",
        "cancelled",
        "handed_off_to_office",
        "fulfillment_pending",
      ].indexOf(order.state) !== -1
    )
      return "history";
    if (order.state === "declined") return "waiting";
    if (
      [
        "awaiting_supplier",
        "preflight",
        "revision_requested",
        "approved_for_production",
        "ready_to_ship",
      ].indexOf(order.state) !== -1
    )
      return "action";
    if (["in_production", "quality_check"].indexOf(order.state) !== -1)
      return "progress";
    return "waiting";
  }

  function updateQueueCounts() {
    ["action", "progress", "waiting", "history"].forEach(function (bucket) {
      var element = root.querySelector(
        '[data-supplier-bucket-count="' + bucket + '"]',
      );
      if (element) element.textContent = queueCounts[bucket] || 0;
    });
  }

  function filteredOrders() {
    if (!isPreview) return orders.slice();
    var term = String((search && search.value) || "")
      .trim()
      .toLowerCase();
    var selectedStatus = status && status.value;
    var filtered = orders.filter(function (order) {
      if (bucketFor(order) !== activeBucket) return false;
      if (urgency.value && order.urgency !== urgency.value) return false;
      if (selectedStatus && order.state !== selectedStatus) return false;
      if (!term) return true;
      var delivery = order.delivery || {};
      var haystack = [
        order.shopify_order_name,
        order.state,
        delivery.recipient_name,
        delivery.company,
      ]
        .concat(
          (order.lines || []).map(function (line) {
            return (
              line.title +
              " " +
              (line.sku || "") +
              " " +
              (line.variant_title || "")
            );
          }),
        )
        .join(" ")
        .toLowerCase();
      return haystack.indexOf(term) !== -1;
    });
    return workflowModel && typeof workflowModel.sortOrders === "function"
      ? workflowModel.sortOrders(filtered, sort.value || "newest")
      : filtered;
  }

  function updateStatusOptions() {
    var current = status.value;
    var states = isPreview
      ? orders
          .filter(function (order) {
            return bucketFor(order) === activeBucket;
          })
          .map(function (order) {
            return { value: order.state };
          })
      : statusFacets;
    states = states
      .map(function (facet) {
        return facet.value;
      })
      .filter(function (value, index, values) {
        return values.indexOf(value) === index;
      })
      .sort(function (a, b) {
        return stateLabel(a).localeCompare(stateLabel(b));
      });
    status.innerHTML =
      '<option value="">' +
      esc(
        root.querySelector("[data-supplier-status] option")
          ? root.querySelector("[data-supplier-status] option").textContent
          : "All statuses",
      ) +
      "</option>" +
      states
        .map(function (state) {
          return (
            '<option value="' +
            esc(state) +
            '"' +
            (state === current ? " selected" : "") +
            ">" +
            esc(stateLabel(state)) +
            "</option>"
          );
        })
        .join("");
    if (states.indexOf(current) === -1) status.value = "";
  }

  function queueItem(order) {
    var line = (order.lines || [])[0] || {};
    var quantity = (order.lines || []).reduce(function (total, item) {
      return total + Number(item.quantity || 0);
    }, 0);
    var dueClass =
      order.urgency === "overdue"
        ? " is-overdue"
        : order.urgency === "due_soon"
          ? " is-due-soon"
          : "";
    return (
      '<button type="button" class="bb-supplier__queue-item' +
      (order.id === selectedId ? " is-selected" : "") +
      '" data-supplier-order="' +
      esc(order.id) +
      '" aria-current="' +
      (order.id === selectedId ? "true" : "false") +
      '">' +
      '<span class="bb-supplier__queue-top"><strong>' +
      esc(order.shopify_order_name) +
      "</strong>" +
      orderStatusBadgeHtml(order) +
      "</span>" +
      '<span class="bb-supplier__queue-title">' +
      esc(line.title || strings.customProduct) +
      ((order.lines || []).length > 1
        ? " <small>+" + ((order.lines || []).length - 1) + "</small>"
        : "") +
      "</span>" +
      '<span class="bb-supplier__queue-meta"><span>' +
      esc(strings.quantity) +
      " " +
      esc(quantity) +
      "</span><span>" +
      esc(money(order.po_total, order.po_currency)) +
      '</span><span class="bb-supplier__due' +
      dueClass +
      '">' +
      (order.urgency === "overdue" ? esc(strings.overdue) : esc(strings.due)) +
      " " +
      esc(date(order.in_hand_delivery_date)) +
      "</span></span></button>"
    );
  }

  function emptyListHtml(hasFilters) {
    var isEmptyAccount = orders.length === 0;
    var title = isEmptyAccount
      ? strings.noOrders
      : hasFilters
        ? strings.noMatches
        : strings.allCaughtUp;
    var help = isEmptyAccount
      ? strings.noOrdersHelp
      : hasFilters
        ? strings.noMatchesHelp
        : strings.allCaughtUpHelp;
    return (
      '<div class="bb-supplier__empty"><span aria-hidden="true">✓</span><h2>' +
      esc(title) +
      "</h2><p>" +
      esc(help) +
      "</p>" +
      (hasFilters
        ? '<button type="button" class="bb-btn bb-btn--secondary" data-supplier-clear-inline>' +
          esc(strings.clearFilters || "Clear filters") +
          "</button>"
        : "") +
      "</div>"
    );
  }

  function renderEmptyDetail() {
    detailRoot.removeAttribute("aria-busy");
    detailContent.innerHTML =
      '<div class="bb-supplier__empty bb-supplier__empty--detail"><span aria-hidden="true">→</span><h2>' +
      esc(strings.selectOrder) +
      "</h2><p>" +
      esc(strings.selectOrderHelp) +
      "</p></div>";
  }

  function renderDetailLoading() {
    detailRoot.setAttribute("aria-busy", "true");
    detailContent.innerHTML =
      '<div class="bb-supplier__detail-loading" aria-label="' +
      esc(strings.loadingWorkOrders) +
      '"><span></span><span></span><span></span></div>';
  }

  function renderListLoading() {
    orders = [];
    count.textContent = strings.loadingWorkOrders;
    paginationRoot.hidden = true;
    listRoot.setAttribute("aria-busy", "true");
    listRoot.innerHTML =
      '<div class="bb-supplier__loading bb-supplier__queue-skeleton" aria-label="' +
      esc(strings.loadingWorkOrders) +
      '"><span></span><span></span><span></span></div>';
  }

  function detailPanelSkeletonHtml(title, description) {
    return panelHtml(
      title,
      '<div class="bb-supplier__panel-skeleton" aria-hidden="true"><span></span><span></span><span></span></div>',
      { description: description || "" },
    );
  }

  function renderDetailSummary(order) {
    renderDetail(order, { partial: true, announce: true });
  }

  function syncSelectionAfterFilter(filtered) {
    var selectedVisible = filtered.some(function (order) {
      return order.id === selectedId;
    });
    if (selectedVisible) return;
    selectedId = "";
    renderEmptyDetail();
    if (mobileQuery.matches) {
      closeMobileDetail(false);
      return;
    }
    if (filtered[0]) loadDetail(filtered[0].id, { updateHistory: false });
  }

  function renderList(syncSelection) {
    var filtered = filteredOrders();
    var hasFilters = Boolean(
      String(search.value || "").trim() || status.value || urgency.value,
    );
    var total = isPreview ? filtered.length : pagination.total;
    count.textContent =
      total + " " + (total === 1 ? strings.assignment : strings.assignments);
    clearFilters.hidden = !hasFilters;
    updateFilterCount();
    listRoot.removeAttribute("aria-busy");
    listRoot.innerHTML = filtered.length
      ? filtered.map(queueItem).join("")
      : emptyListHtml(hasFilters);
    renderPagination();
    if (syncSelection !== false) syncSelectionAfterFilter(filtered);
  }

  function renderPagination() {
    var total = isPreview ? filteredOrders().length : pagination.total;
    var currentPage = isPreview ? 1 : pagination.page;
    var pageCount = isPreview ? 1 : pagination.page_count;
    var start = total ? (currentPage - 1) * pagination.page_size + 1 : 0;
    var end = Math.min(total, currentPage * pagination.page_size);
    paginationRoot.hidden = false;
    pageSummary.textContent = (
      strings.pageSummary || "__START__–__END__ of __TOTAL__"
    )
      .replace("__START__", start)
      .replace("__END__", end)
      .replace("__TOTAL__", total);
    previousPage.disabled = currentPage <= 1;
    nextPage.disabled = currentPage >= pageCount;
    pageSizeControl.value = String(pagination.page_size || pageSize);
  }

  function visibleItemAttributes(attributes) {
    var hiddenKeys = [
      "design preview",
      "design preview back",
      "zakeke design id",
      "zakeke preview image",
      "zakeke preview image back",
    ];
    if (!Array.isArray(attributes)) return [];
    return attributes.filter(function (item) {
      var key = item && String(item.key || "").trim();
      return (
        key &&
        key.charAt(0) !== "_" &&
        hiddenKeys.indexOf(key.toLowerCase()) === -1 &&
        item.value
      );
    });
  }

  function attributesHtml(attributes) {
    var visibleAttributes = visibleItemAttributes(attributes);
    if (!visibleAttributes.length) return "";
    return (
      '<dl class="bb-supplier__item-attributes">' +
      visibleAttributes
        .map(function (item) {
          return (
            "<div><dt>" +
            esc(item.key) +
            "</dt><dd>" +
            attributeValueHtml(item) +
            "</dd></div>"
          );
        })
        .join("") +
      "</dl>"
    );
  }

  function attributeDisplayValue(item) {
    var key = String((item && item.key) || "").trim().toLowerCase();
    var value = String((item && item.value) || "").trim();
    var dateLikeKey = /(^|\s)(date|delivery|due|need by)(\s|$)/i.test(key);
    if (dateLikeKey && /^\d{4}-\d{2}-\d{2}(?:$|T)/.test(value))
      return date(value);
    return value;
  }

  function attributeValueHtml(item) {
    var key = String((item && item.key) || "")
      .trim()
      .toLowerCase();
    var value = attributeDisplayValue(item);
    var isShopifyUpload =
      key === "uploaded design" &&
      /\/uploads\//i.test(value) &&
      (/^https:\/\//i.test(value) || value.charAt(0) === "/");
    if (!isShopifyUpload) return esc(value);
    return (
      '<a href="' +
      esc(value) +
      '" target="_blank" rel="noopener">' +
      esc(strings.downloadUploadedDesign) +
      "</a>"
    );
  }

  function panelHtml(title, body, options) {
    options = options || {};
    return (
      '<section class="bb-card bb-supplier__panel' +
      (options.className ? " " + esc(options.className) : "") +
      '"><header class="bb-supplier__panel-header"><div><h3>' +
      esc(title) +
      "</h3>" +
      (options.description ? "<p>" + esc(options.description) + "</p>" : "") +
      "</div>" +
      (options.trailing || "") +
      '</header><div class="bb-supplier__panel-body">' +
      body +
      "</div></section>"
    );
  }

  function itemMediaIconHtml() {
    return '<svg viewBox="0 0 24 24"><path d="M5 7.5 12 4l7 3.5v9L12 20l-7-3.5v-9ZM5 7.5l7 3.5 7-3.5M12 11v9"/></svg>';
  }

  function itemMediaHtml(line) {
    var groups = thumbnails.imageGroups
      ? thumbnails.imageGroups(line, cfg.productPlaceholderUrl)
      : [];
    if (groups.length) {
      return (
        '<span class="bb-supplier__item-media-stack">' +
        groups
          .map(function (group) {
            var candidates = group.candidates;
            var roleLabel =
              group.role === "front"
                ? " front design preview"
                : group.role === "back"
                  ? " back design preview"
                  : "";
            return (
              '<span class="bb-supplier__item-media" data-image-role="' +
              esc(group.role) +
              '"><img src="' +
              esc(candidates[0].url) +
              '" alt="' +
              esc((line.title || strings.customProduct) + roleLabel) +
              '" loading="lazy" data-supplier-item-image data-image-optional="' +
              (group.optional ? "true" : "false") +
              '" data-image-index="0" data-image-kind="' +
              esc(candidates[0].kind) +
              '" data-image-candidates="' +
              esc(encodeURIComponent(JSON.stringify(candidates))) +
              '"></span>'
            );
          })
          .join("") +
        "</span>"
      );
    }
    return (
      '<span class="bb-supplier__item-media-stack"><span class="bb-supplier__item-media" aria-hidden="true">' +
      itemMediaIconHtml() +
      "</span></span>"
    );
  }

  function itemsHtml(order) {
    return (order.lines || [])
      .map(function (line) {
        return (
          '<li class="bb-supplier__item-row">' +
          itemMediaHtml(line) +
          '<div class="bb-supplier__item-copy"><div class="bb-supplier__item-heading"><strong>' +
          esc(line.title || strings.customProduct) +
          '</strong><div class="bb-supplier__item-quantity"><span>' +
          esc(strings.quantity) +
          "</span><strong>" +
          esc(line.quantity || 0) +
          '</strong></div></div><small class="bb-supplier__item-meta">' +
          esc(
            [line.variant_title, line.sku].filter(Boolean).join(" · ") ||
              strings.noSku,
          ) +
          "</small>" +
          attributesHtml(line.custom_attributes) +
          "</div></li>"
        );
      })
      .join("");
  }

  function poHtml(order) {
    var adjustments = Array.isArray(order.po_adjustments)
      ? order.po_adjustments
      : [];
    var body =
      "<dl>" +
      "<div><dt>" +
      esc(strings.itemsSubtotal) +
      "</dt><dd>" +
      esc(money(order.po_subtotal, order.po_currency)) +
      "</dd></div>" +
      adjustments
        .map(function (item) {
          return (
            "<div><dt>" +
            esc(item.label) +
            "</dt><dd>" +
            esc(money(item.amount, order.po_currency)) +
            "</dd></div>"
          );
        })
        .join("") +
      '<div class="bb-supplier__po-total"><dt>' +
      esc(strings.agreedTotal) +
      "</dt><dd>" +
      esc(money(order.po_total, order.po_currency)) +
      "</dd></div></dl>" +
      (order.po_locked_at
        ? '<p class="bb-supplier__muted">' + esc(strings.termsLocked) + "</p>"
        : "");
    return panelHtml(strings.purchaseOrder, body, {
      className: "bb-supplier__po",
      description: strings.commercialTerms,
    });
  }

  function scheduleHtml(order) {
    return panelHtml(
      strings.scheduleDelivery || "Schedule & delivery",
      '<dl class="bb-supplier__detail-meta"><div><dt>' +
        esc(strings.customerNeedBy) +
        "</dt><dd>" +
        esc(date(order.in_hand_delivery_date)) +
        "</dd></div><div><dt>" +
        esc(strings.delivery) +
        "</dt><dd>" +
        esc(
          order.shipping_mode === "office_handoff"
            ? strings.officeHandoff
            : strings.directCustomer,
        ) +
        "</dd></div></dl>",
    );
  }

  function officeDelivery(order) {
    var delivery = order.delivery || {};
    var officeHint = String(
      delivery.key ||
        delivery.display_name ||
        delivery.office ||
        order.handoff_office ||
        "",
    ).toLowerCase();
    var fallback =
      OFFICE_HANDOFFS[delivery.key] ||
      (officeHint.indexOf("las vegas") !== -1
        ? OFFICE_HANDOFFS.c2r_las_vegas
        : officeHint.indexOf("miami") !== -1
          ? OFFICE_HANDOFFS.c2r_miami
          : {});

    function value(key) {
      var supplied = delivery[key];
      return supplied == null || String(supplied).trim() === ""
        ? fallback[key] || ""
        : supplied;
    }

    return {
      display_name:
        value("display_name") || delivery.office || order.handoff_office || "",
      company_name: value("company_name"),
      attention: value("attention"),
      address1: value("address1"),
      address2: value("address2"),
      city: value("city"),
      province_code: value("province_code"),
      postal_code: value("postal_code"),
      country_code: value("country_code"),
      phone: value("phone"),
    };
  }

  function officeDeliveryLines(order) {
    var office = officeDelivery(order);
    var region = [office.province_code, office.postal_code]
      .filter(Boolean)
      .join(" ");
    var locality = [office.city, region].filter(Boolean).join(", ");
    var country = office.country_code === "US" ? "USA" : office.country_code;
    return {
      office: office,
      locality: locality,
      country: country,
      lines: [
        office.company_name || office.display_name,
        office.attention ? "Att: " + office.attention : "",
        office.address1,
        office.address2,
        locality,
        country,
        office.phone,
      ].filter(Boolean),
    };
  }

  function officeDeliveryHtml(order) {
    var address = officeDeliveryLines(order);
    var office = address.office;
    var phoneHref = String(office.phone || "").replace(/[^+\d]/g, "");
    return (
      "<address>" +
      (address.lines[0]
        ? "<strong>" + esc(address.lines[0]) + "</strong>"
        : "") +
      (office.attention
        ? "<span>Att: " + esc(office.attention) + "</span>"
        : "") +
      (office.address1 ? "<span>" + esc(office.address1) + "</span>" : "") +
      (office.address2 ? "<span>" + esc(office.address2) + "</span>" : "") +
      (address.locality ? "<span>" + esc(address.locality) + "</span>" : "") +
      (address.country ? "<span>" + esc(address.country) + "</span>" : "") +
      (office.phone
        ? '<a href="tel:' + esc(phoneHref) + '">' + esc(office.phone) + "</a>"
        : "") +
      "</address>"
    );
  }

  function officeDeliveryPrintHtml(order) {
    var address = officeDeliveryLines(order);
    return (
      "<p><strong>" +
      esc(strings.officeHandoff) +
      "</strong><br>" +
      address.lines.map(esc).join("<br>") +
      "</p>"
    );
  }

  function deliveryHtml(order) {
    var delivery = order.delivery || {};
    if (order.shipping_mode === "office_handoff") {
      return panelHtml(strings.deliveryHandoff, officeDeliveryHtml(order));
    }
    var region = [
      delivery.city,
      delivery.province_code || delivery.province,
      delivery.postal_code,
    ]
      .filter(Boolean)
      .join(", ");
    return panelHtml(
      strings.directDelivery,
      "<address>" +
        (delivery.recipient_name
          ? "<strong>" + esc(delivery.recipient_name) + "</strong>"
          : "") +
        (delivery.company ? "<span>" + esc(delivery.company) + "</span>" : "") +
        (delivery.address1
          ? "<span>" + esc(delivery.address1) + "</span>"
          : "") +
        (delivery.address2
          ? "<span>" + esc(delivery.address2) + "</span>"
          : "") +
        (region ? "<span>" + esc(region) + "</span>" : "") +
        (delivery.country || delivery.country_code
          ? "<span>" +
            esc(delivery.country || delivery.country_code) +
            "</span>"
          : "") +
        (delivery.phone
          ? '<a href="tel:' +
            esc(delivery.phone) +
            '">' +
            esc(delivery.phone) +
            "</a>"
          : "") +
        "</address>",
    );
  }

  function resourceRowHtml(options) {
    var statusMarkup = options.status
      ? '<span class="bb-supplier__resource-status">' +
        esc(options.status) +
        "</span>"
      : "";
    return (
      '<a class="bb-supplier__resource-row" href="' +
      esc(options.url) +
      '"' +
      (options.external ? ' target="_blank" rel="noopener"' : "") +
      '><span class="bb-supplier__resource-icon" aria-hidden="true">' +
      esc(options.type || strings.fileLabel) +
      '</span><span class="bb-supplier__resource-copy"><strong>' +
      esc(options.title || strings.orderFile) +
      "</strong>" +
      (options.meta ? "<small>" + esc(options.meta) + "</small>" : "") +
      "</span>" +
      statusMarkup +
      '<svg class="bb-supplier__resource-arrow" viewBox="0 0 20 20" aria-hidden="true"><path d="M7 4h9v9M16 4 6 14M14 16H4V6"/></svg></a>'
    );
  }

  function fileTypeText(file) {
    var mediaType = String(file.media_type || "").toLowerCase();
    var extension = String(file.name || "")
      .split(".")
      .pop();
    if (mediaType.indexOf("image/") === 0) return "IMG";
    if (mediaType.indexOf("pdf") !== -1) return "PDF";
    if (extension && extension.length <= 4) return extension.toUpperCase();
    return strings.fileLabel || "File";
  }

  function fileLink(order, file) {
    return resourceRowHtml({
      url: isPreview
        ? "#preview-file"
        : cfg.endpoint +
          "/" +
          encodeURIComponent(order.id) +
          "/files/" +
          encodeURIComponent(file.id),
      external: !isPreview,
      type: fileTypeText(file),
      title: file.name || strings.orderFile,
      meta: fileTypeText(file) + " " + strings.fileLabel,
    });
  }

  function productionFilesForOrder(order) {
    var files = Array.isArray(order.production_files)
      ? order.production_files
      : [];
    return productionFileModel.displayFiles
      ? productionFileModel.displayFiles(files)
      : files;
  }

  function productionFileResourceHtml(order, file) {
    var url = isPreview
      ? "#preview-production-file"
      : cfg.endpoint +
        "/" +
        encodeURIComponent(order.id) +
        "/production-files/" +
        encodeURIComponent(file.id);
    return resourceRowHtml({
      url: url,
      external: !isPreview,
      type: file.file_type || strings.fileLabel,
      title: file.is_zip
        ? strings.productionFiles
        : file.name || strings.productionFile,
      meta: file.is_zip
        ? strings.productionFilesHelp
        : [file.file_type, file.modification_id].filter(Boolean).join(" · "),
      status: strings.ready,
    });
  }

  function productionPackageDialogHtml(order) {
    var files = productionFilesForOrder(order);
    if (!files.length) return "";
    return dialogSection(
      strings.productionPackage || "Production package",
      '<div class="bb-supplier__production-package bb-supplier__production-package--dialog"><p><strong>' +
        esc(strings.productionPackageReady || "Current production files") +
        "</strong><span>" +
        esc(
          strings.productionPackageStartHelp ||
            "Download and review this package before starting production.",
        ) +
        '</span></p><div class="bb-supplier__resource-list">' +
        files
          .map(function (file) {
            return productionFileResourceHtml(order, file);
          })
          .join("") +
        "</div></div>",
      "bb-supplier__dialog-section--production-package",
    );
  }

  function filesHtml(order) {
    var files = (Array.isArray(order.files) ? order.files : []).filter(
      function (file) {
        return (
          String((file.name || "") + " " + (file.id || ""))
            .toLowerCase()
            .indexOf("invoice") === -1
        );
      },
    );
    var productionFiles = productionFilesForOrder(order);
    var proofs = Array.isArray(order.proofs) ? order.proofs : [];
    var productionMarkup = "";
    if (productionFiles.length) {
      var productionBody =
        '<div class="bb-supplier__resource-list">' +
        productionFiles
          .map(function (file) {
            return productionFileResourceHtml(order, file);
          })
          .join("") +
        "</div>";
      productionMarkup = panelHtml(strings.productionFiles, productionBody, {
        description: strings.productionFilesHelp,
        className: "bb-supplier__production-package",
      });
    } else if (order.state === "awaiting_production_files") {
      productionMarkup = panelHtml(
        strings.preparingFiles,
        "<p>" + esc(strings.preparingFilesHelp) + "</p>",
        {
          className: "bb-supplier__callout",
        },
      );
    }
    var proofMarkup = proofs
      .map(function (proof) {
        var proofFiles = Array.isArray(proof.files) ? proof.files : [];
        return (
          '<article class="bb-supplier__proof-version"><header class="bb-supplier__proof-version-head"><strong>' +
          esc(strings.proofVersion) +
          " " +
          esc(proof.version) +
          "</strong>" +
          statusBadgeHtml(proof.status, stateLabel(proof.status)) +
          "</header>" +
          (proof.customer_feedback
            ? '<div class="bb-supplier__proof-feedback"><strong>' +
              esc(strings.customerFeedback) +
              "</strong><p>" +
              esc(proof.customer_feedback) +
              "</p></div>"
            : "") +
          '<div class="bb-supplier__resource-list">' +
          proofFiles
            .map(function (file) {
              return fileLink(order, file);
            })
            .join("") +
          "</div></article>"
        );
      })
      .join("");
    var otherMarkup = files.length
      ? '<div class="bb-supplier__resource-list bb-supplier__resource-list--other">' +
        files
          .map(function (file) {
            return fileLink(order, file);
          })
          .join("") +
        "</div>"
      : "";
    if (!proofMarkup && !otherMarkup) return productionMarkup;
    return (
      productionMarkup +
      panelHtml(
        strings.proofsFiles,
        '<div class="bb-supplier__proof-history">' +
          proofMarkup +
          otherMarkup +
          "</div>",
      )
    );
  }

  function fulfillmentHtml(order) {
    if (!order.tracking_number && !order.invoice_disposition) return "";
    return panelHtml(
      strings.fulfillmentSubmitted,
      '<dl class="bb-supplier__detail-meta"><div><dt>' +
        esc(strings.tracking) +
        "</dt><dd>" +
        esc(order.tracking_number || "—") +
        "</dd></div><div><dt>" +
        esc(strings.carrier) +
        "</dt><dd>" +
        esc(order.tracking_company || "—") +
        "</dd></div><div><dt>" +
        esc(strings.invoice) +
        "</dt><dd>" +
        esc(
          order.invoice_disposition === "office_handoff"
            ? strings.handedTo + " " + (order.invoice_office || "office")
            : strings.uploaded,
        ) +
        "</dd></div></dl>",
    );
  }

  function actionCopy(action) {
    return (
      {
        accept: [
          strings.acceptOrder,
          strings.acceptOrderHelp,
          strings.acceptOrder,
        ],
        decline: [
          strings.declineOrder,
          strings.declineHelp,
          strings.declineOrder,
        ],
        submit_proof: [
          strings.sendProof,
          strings.sendProofHelp,
          strings.sendProof,
        ],
        start_production: [
          strings.startProduction,
          strings.startProductionHelp,
          strings.startProduction,
        ],
        submit_fulfillment: [
          strings.addTracking,
          strings.addTrackingHelp,
          strings.addTracking,
        ],
      }[action] || [label(action), "", strings.confirm]
    );
  }

  function actionIcon(action) {
    var paths = {
      accept: '<circle cx="12" cy="12" r="9"/><path d="m8 12 3 3 5-6"/>',
      decline: '<path d="m6 6 12 12M18 6 6 18"/>',
      submit_proof: '<path d="M12 16V3m-5 5 5-5 5 5M4 15v5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5"/>',
      start_production: '<path d="m8 4 12 8-12 8V4Z"/>',
      submit_fulfillment: '<path d="M3 5h11v12H3zM14 9h4l3 4v4h-7"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>',
    };
    return paths[action]
      ? '<svg class="bb-supplier__action-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + paths[action] + '</svg>'
      : '';
  }

  function actionButtons(order) {
    return (order.allowed_actions || [])
      .map(function (action) {
        var actionText = actionCopy(action);
        var buttonClass =
          action === "decline"
            ? "bb-btn--danger-quiet"
            : action === "submit_proof"
              ? "bb-btn--secondary"
              : "bb-btn--primary";
        return (
          '<button type="button" class="bb-btn ' +
          buttonClass +
          '" data-supplier-action="' +
          esc(action) +
          '">' +
          actionIcon(action) +
          '<span>' +
          esc(actionText[0]) +
          "</span></button>"
        );
      })
      .join("");
  }

  function eventLabel(action) {
    var labels = {
      order_ingested: strings.orderReceived,
      production_files_ready: strings.productionFilesReadyEvent,
      zakeke_files_requested: strings.productionFilesRequestedEvent,
      zakeke_files_ready: strings.productionFilesReadyEvent,
      zakeke_files_delayed: strings.productionFilesDelayedEvent,
      zakeke_files_failed: strings.productionFilesAttentionEvent,
      zakeke_files_changed: strings.productionFilesUpdatedEvent,
      zakeke_files_changed_after_production:
        strings.productionFilesUpdatedAfterStartEvent,
      zakeke_ready_reconciled: strings.productionFilesConfirmedEvent,
      retry_zakeke: strings.productionFilesRequestedAgainEvent,
      approve_zakeke_revision: strings.productionFilesRevisionApprovedEvent,
      reject_zakeke_revision: strings.productionFilesRevisionDeclinedEvent,
      supplier_assigned: strings.supplierAssignedEvent,
      accept: strings.acceptOrder,
      approve_preflight: strings.approvePreflight,
      production_started: strings.productionStartedEvent,
      proof_submitted: strings.proofSubmittedEvent,
      revision_requested: strings.revisionRequested,
      order_completed: strings.orderCompletedEvent,
      fulfillment_submitted: strings.fulfillmentSubmitted,
      start_production: strings.productionStartedEvent,
      begin_quality_check: strings.beginQualityCheck,
      mark_ready_to_ship: strings.markReadyToShip,
      submit_proof: strings.proofSubmittedEvent,
      submit_fulfillment: strings.fulfillmentSubmitted,
      decline: strings.declined,
    };
    if (labels[action]) return labels[action];
    if (/zakeke/i.test(String(action || "")))
      return strings.productionFilesUpdatedEvent || "Production files updated";
    return label(action);
  }

  function actorLabel(actorType) {
    return (
      {
        supplier: strings.actorSupplier,
        customer: strings.actorCustomer,
        staff: strings.actorStaff,
        system: strings.actorSystem,
      }[actorType] || strings.actorSystem
    );
  }

  function eventsHtml(order) {
    var events = (order.events || [])
      .slice()
      .sort(function (a, b) {
        return (
          new Date(b.created_at || 0).getTime() -
          new Date(a.created_at || 0).getTime()
        );
      })
      .map(function (event) {
        var eventMeta = [
          actorLabel(event.actor_type),
          dateTime(event.created_at),
        ]
          .filter(Boolean)
          .join(" · ");
        return (
          '<li><span aria-hidden="true"></span><div><strong>' +
          esc(eventLabel(event.action)) +
          "</strong>" +
          (event.reason ? "<p>" + esc(event.reason) + "</p>" : "") +
          "<small>" +
          esc(eventMeta) +
          "</small></div></li>"
        );
      })
      .join("");
    return panelHtml(
      strings.activity,
      events
        ? '<ol class="bb-supplier__timeline">' + events + "</ol>"
        : '<p class="bb-supplier__muted">' + esc(strings.activityHelp) + "</p>",
      { description: strings.activityHelp },
    );
  }

  function progressSummaryHtml(order) {
    if (["declined", "cancelled"].indexOf(order.state) !== -1) {
      return (
        '<section class="bb-supplier__progress-summary is-terminal"><div><span>' +
        esc(strings.progress) +
        "</span><strong>" +
        esc(orderStateLabel(order)) +
        "</strong></div></section>"
      );
    }
    var progress = workflowModel.progressForWorkOrder
      ? workflowModel.progressForWorkOrder(order)
      : {
          stages: order.proof_required
            ? ["proof", "production", "shipment"]
            : ["preparation", "production", "shipment"],
          currentIndex: 0,
        };
    var stageLabels = {
      preparation: strings.stagePreparation,
      proof: strings.stageProof,
      production: strings.stageProduction,
      shipment: strings.stageShipment,
    };
    var stages = progress.stages.map(function (stage) {
      return stageLabels[stage] || label(stage);
    });
    var current = Math.max(1, Number(progress.currentIndex) + 1);
    var stepText = (strings.stepOf || "Step __CURRENT__ of __TOTAL__")
      .replace("__CURRENT__", current)
      .replace("__TOTAL__", stages.length);
    return (
      '<section class="bb-supplier__progress-summary"><div class="bb-supplier__progress-copy"><span>' +
      esc(strings.progress) +
      "</span><strong>" +
      esc(stages[current - 1]) +
      '</strong></div><span class="bb-supplier__progress-step">' +
      esc(stepText) +
      '</span><div class="bb-supplier__progress-track" role="progressbar" aria-label="' +
      esc(strings.progress) +
      '" aria-valuemin="1" aria-valuemax="' +
      stages.length +
      '" aria-valuenow="' +
      current +
      '"><span style="width:' +
      (current / stages.length) * 100 +
      '%"></span></div></section>'
    );
  }

  function printDeliveryHtml(order) {
    var delivery = order.delivery || {};
    if (order.shipping_mode === "office_handoff") {
      return officeDeliveryPrintHtml(order);
    }
    var address = [
      delivery.recipient_name,
      delivery.company,
      delivery.address1,
      delivery.address2,
      [
        delivery.city,
        delivery.province_code || delivery.province,
        delivery.postal_code,
      ]
        .filter(Boolean)
        .join(", "),
      delivery.country || delivery.country_code,
      delivery.phone,
      delivery.email,
    ].filter(Boolean);
    return (
      "<p><strong>" +
      esc(strings.directCustomer) +
      "</strong><br>" +
      address.map(esc).join("<br>") +
      "</p>"
    );
  }

  function renderPrintTicket(order) {
    var lines = (order.lines || [])
      .map(function (line) {
        var attrs = visibleItemAttributes(line.custom_attributes)
          .map(function (item) {
            return esc(item.key) + ": " + esc(attributeDisplayValue(item));
          })
          .join(" · ");
        return (
          "<tr><td><strong>" +
          esc(line.title || strings.customProduct) +
          "</strong>" +
          (line.variant_title
            ? "<br><span>" + esc(line.variant_title) + "</span>"
            : "") +
          (attrs ? "<br><small>" + attrs + "</small>" : "") +
          "</td><td>" +
          esc(line.sku || strings.noSku) +
          "</td><td>" +
          esc(line.quantity || 0) +
          "</td></tr>"
        );
      })
      .join("");
    var references = [];
    var ticketProductionFiles = productionFileModel.displayFiles
      ? productionFileModel.displayFiles(order.production_files || [])
      : order.production_files || [];
    ticketProductionFiles.forEach(function (file) {
      references.push(
        (file.file_type || strings.productionFile) +
          (file.modification_id ? " · " + file.modification_id : ""),
      );
    });
    (order.proofs || []).forEach(function (proof) {
      (proof.files || []).forEach(function (file) {
        references.push(
          (strings.proofVersion || "Proof version") +
            " " +
            proof.version +
            " · " +
            (file.name || strings.fileLabel),
        );
      });
    });
    (order.files || []).forEach(function (file) {
      var identity = String(
        (file.name || "") + " " + (file.id || ""),
      ).toLowerCase();
      if (identity.indexOf("invoice") === -1)
        references.push(file.name || strings.orderFile);
    });
    return (
      '<article id="BBSupplierPrintTicket" class="bb-supplier__print-ticket" aria-hidden="true">' +
      "<header><div><span>BadgeBuzz</span><h1>" +
      esc(strings.productionJobTicket || "Production job ticket") +
      "</h1></div>" +
      "<div><strong>" +
      esc(order.shopify_order_name) +
      "</strong><span>" +
      esc(orderStateLabel(order)) +
      "</span></div></header>" +
      '<dl class="bb-supplier__print-meta"><div><dt>' +
      esc(strings.generated || "Generated") +
      "</dt><dd>" +
      esc(dateTime(new Date().toISOString())) +
      "</dd></div><div><dt>" +
      esc(strings.customerNeedBy) +
      "</dt><dd>" +
      esc(date(order.in_hand_delivery_date)) +
      "</dd></div></dl>" +
      "<section><h2>" +
      esc(strings.items) +
      "</h2><table><thead><tr><th>Item / specifications</th><th>SKU</th><th>" +
      esc(strings.quantity) +
      "</th></tr></thead><tbody>" +
      lines +
      "</tbody></table></section>" +
      "<section><h2>" +
      esc(strings.productionFiles) +
      "</h2>" +
      (references.length
        ? "<ul>" +
          references
            .map(function (reference) {
              return "<li>" + esc(reference) + "</li>";
            })
            .join("") +
          "</ul>"
        : "<p>—</p>") +
      "</section>" +
      "<section><h2>" +
      esc(strings.scheduleDelivery || strings.delivery) +
      "</h2>" +
      printDeliveryHtml(order) +
      "</section></article>"
    );
  }

  function removePrintTicket() {
    var existing = document.getElementById("BBSupplierPrintTicket");
    if (existing) existing.remove();
  }

  function preparePrintTicket() {
    removePrintTicket();
    if (!currentOrder) return null;
    document.body.insertAdjacentHTML(
      "beforeend",
      renderPrintTicket(currentOrder),
    );
    return document.getElementById("BBSupplierPrintTicket");
  }

  function renderDetail(order, options) {
    options = options || {};
    if (!order) {
      renderEmptyDetail();
      return;
    }
    selectedId = order.id;
    currentOrder = order;
    var line = (order.lines || [])[0] || {};
    var actionInner = (order.allowed_actions || []).length
      ? actionButtons(order)
      : "";
    var mobileActions = actionInner
      ? panelHtml(
          strings.availableActions,
          '<div class="bb-supplier__action-list">' + actionInner + "</div>",
          {
            className:
              "bb-supplier__detail-actions bb-supplier__action-placement--mobile",
          },
        ).replace(
          'class="bb-card',
          'data-supplier-action-mobile class="bb-card',
        )
      : "";
    var desktopActions = actionInner
      ? panelHtml(
          strings.availableActions,
          '<div class="bb-supplier__action-list">' + actionInner + "</div>",
          {
            className:
              "bb-supplier__detail-actions bb-supplier__action-placement--desktop",
          },
        ).replace(
          'class="bb-card',
          'data-supplier-action-desktop class="bb-card',
        )
      : "";
    var printIcon =
      '<svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18"><path d="M7 9V4h10v5M7 18H5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M7 14h10v6H7z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var responsibility = responsibleLabel(order);
    var responsibilityHtml = responsibility
      ? "<small>" + esc(responsibility) + "</small>"
      : "";
    detailContent.innerHTML =
      '<header class="bb-supplier__detail-header"><div><span class="bb-supplier__eyebrow">' +
      esc(order.shopify_order_name) +
      "</span><h2>" +
      esc(line.title || strings.customProduct) +
      '</h2></div><div class="bb-supplier__detail-header-tools"><button type="button" class="bb-btn bb-btn--ghost bb-supplier__print" data-supplier-print>' +
      printIcon +
      "<span>" +
      esc(strings.printWorkOrder) +
      '</span></button><div class="bb-supplier__detail-status">' +
      orderStatusBadgeHtml(order) +
      responsibilityHtml +
      "</div></div></header>" +
      (order.warehouse_rework_pending && order.warehouse_rework_reason
        ? panelHtml(
            "Quality check rejected — rework required",
            '<p>' + esc(order.warehouse_rework_reason) + '</p><p>Review the approved artwork, then start production or decline this assignment. Submit a new tracking number when the replacement ships.</p>',
          )
        : "") +
      progressSummaryHtml(order) +
      '<div class="bb-supplier__detail-layout"><div class="bb-supplier__detail-main">' +
      panelHtml(
        strings.items,
        '<ul class="bb-supplier__items" role="list">' +
          itemsHtml(order) +
          "</ul>",
      ) +
      (options.partial
        ? detailPanelSkeletonHtml(
            strings.productionFiles,
            strings.productionFilesHelp,
          )
        : filesHtml(order)) +
      mobileActions +
      deliveryHtml(order) +
      (Array.isArray(order.warehouse_rework_history) && order.warehouse_rework_history.length
        ? panelHtml("Previous quality checks", '<ul class="bb-supplier__timeline">' + order.warehouse_rework_history.map(function (entry) {
            var shipment = entry.shipment_snapshot || {};
            return '<li><div><strong>Inbound shipment ' + esc(Number(entry.shipment_cycle) + 1) + '</strong><p>' + esc(entry.reason) + '</p><small>' + esc([shipment.tracking_company, shipment.tracking_number].filter(Boolean).join(' · ')) + ' · ' + esc(dateTime(entry.created_at)) + '</small></div></li>';
          }).join('') + '</ul>')
        : "") +
      fulfillmentHtml(order) +
      '</div><div class="bb-supplier__summary-rail">' +
      (options.partial
        ? detailPanelSkeletonHtml(strings.activity, strings.activityHelp)
        : eventsHtml(order)) +
      desktopActions +
      scheduleHtml(order) +
      poHtml(order) +
      "</div></div>";
    renderList(false);
    detailRoot.classList.toggle("is-summary-loading", Boolean(options.partial));
    if (options.partial) detailRoot.setAttribute("aria-busy", "true");
    else detailRoot.removeAttribute("aria-busy");
    if (options.announce !== false) announce(strings.orderSelected);
  }

  function replaceWorkOrderInUrl(id, method) {
    var url = new URL(window.location.href);
    if (id) url.searchParams.set("work_order", id);
    else url.searchParams.delete("work_order");
    window.history[method || "replaceState"](
      { supplierDetail: Boolean(id), workOrder: id || "" },
      "",
      url,
    );
  }

  function openMobileDetail(id, addHistory) {
    if (!mobileQuery.matches) return;
    root.classList.add("is-mobile-detail");
    if (addHistory) replaceWorkOrderInUrl(id, "pushState");
    window.scrollTo({
      top: 0,
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ? "auto"
        : "smooth",
    });
    window.setTimeout(function () {
      backButton.focus({ preventScroll: true });
    }, 30);
  }

  function closeMobileDetail(updateHistory) {
    root.classList.remove("is-mobile-detail");
    if (updateHistory !== false) replaceWorkOrderInUrl("", "replaceState");
    var queueItems = Array.prototype.slice.call(
      listRoot.querySelectorAll("[data-supplier-order]"),
    );
    var selected =
      queueItems.find(function (item) {
        return item.dataset.supplierOrder === selectedId;
      }) || queueItems[0];
    if (selected)
      window.setTimeout(function () {
        selected.focus({ preventScroll: true });
      }, 30);
  }

  function markNotifications(workOrderId) {
    if (!cfg.notificationEndpoint || isPreview) return;
    notifications
      .filter(function (item) {
        return (
          !item.read_at && String(item.work_order_id) === String(workOrderId)
        );
      })
      .forEach(function (item) {
        item.read_at = new Date().toISOString();
        fetch(
          cfg.notificationEndpoint +
            "/" +
            encodeURIComponent(item.id) +
            "/read",
          {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
            body: "{}",
          },
        ).catch(function () {
          item.read_at = null;
        });
      });
    renderNotifications();
  }

  function renderNotifications() {
    var unreadItems = notifications.filter(function (item) {
      return !item.read_at;
    });
    var unread = unreadItems.length;
    if (!unread) {
      noticeRoot.hidden = true;
      noticeRoot.innerHTML = "";
      return;
    }
    var title =
      unread === 1
        ? strings.newUpdate
        : (strings.newUpdates || "__COUNT__ new updates").replace(
            "__COUNT__",
            unread,
          );
    var targetOrder = unreadItems[0] && unreadItems[0].work_order_id;
    noticeRoot.innerHTML = targetOrder
      ? '<button type="button" data-supplier-notification-order="' +
        esc(targetOrder) +
        '"><strong>' +
        esc(title) +
        "</strong><span>" +
        esc(strings.notificationHelp) +
        "</span></button>"
      : "<strong>" +
        esc(title) +
        "</strong><span>" +
        esc(strings.notificationHelp) +
        "</span>";
    noticeRoot.hidden = false;
  }

  function loadDetail(id, options) {
    options = options || {};
    markNotifications(id);
    selectedId = id;
    renderList(false);
    if (!mobileQuery.matches && options.updateHistory !== false)
      replaceWorkOrderInUrl(id, "replaceState");
    var cached = detailCache[id];
    var summary = orders.find(function (order) {
      return order.id === id;
    });
    if (cached) renderDetail(cached, { announce: options.announce !== false });
    else if (summary) renderDetailSummary(summary);
    else renderDetailLoading();
    if (isPreview) {
      var previewOrder = summary || cached;
      if (previewOrder) {
        detailCache[id] = previewOrder;
        renderDetail(previewOrder, { announce: false });
      }
      return Promise.resolve();
    }
    if (detailRequestId === id && detailRequestPromise)
      return detailRequestPromise;
    if (detailRequestController) detailRequestController.abort();
    detailRequestController = new AbortController();
    detailRequestId = id;
    detailRequestToken += 1;
    var requestToken = detailRequestToken;
    detailRoot.setAttribute("aria-busy", "true");
    detailRoot.classList.toggle("is-refreshing", Boolean(cached));
    detailRequestPromise = requestJson(
      cfg.endpoint + "/" + encodeURIComponent(id),
      {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        signal: detailRequestController.signal,
      },
    )
      .then(function (order) {
        if (requestToken !== detailRequestToken || selectedId !== id) return;
        detailCache[id] = order;
        var index = orders.findIndex(function (item) {
          return item.id === order.id;
        });
        if (index !== -1) orders[index] = order;
        renderDetail(order, { announce: false });
      })
      .catch(function (error) {
        if (error.name === "AbortError") return;
        if (requestToken !== detailRequestToken || selectedId !== id) return;
        if (cached || summary) {
          detailContent
            .querySelectorAll(".bb-supplier__panel-skeleton")
            .forEach(function (skeleton) {
              skeleton.outerHTML =
                '<p class="bb-supplier__muted">' +
                esc(strings.detailError) +
                "</p>";
            });
          detailRoot.classList.remove("is-summary-loading");
          announce(strings.detailError);
          return;
        }
        detailContent.innerHTML =
          '<div class="bb-supplier__empty"><span aria-hidden="true">!</span><h2>' +
          esc(strings.detailError) +
          "</h2><p>" +
          esc(error.message) +
          "</p></div>";
      })
      .finally(function () {
        if (requestToken !== detailRequestToken) return;
        detailRequestId = "";
        detailRequestPromise = null;
        detailRoot.classList.remove("is-refreshing");
        if (!detailRoot.classList.contains("is-summary-loading"))
          detailRoot.removeAttribute("aria-busy");
      });
    return detailRequestPromise;
  }

  function renderWorkspaceState(title, help, actionHtml) {
    workspace.classList.remove("is-list-loading");
    workspace.classList.add("is-state");
    queueRoot.hidden = true;
    listRoot.removeAttribute("aria-busy");
    detailContent.innerHTML =
      '<div class="bb-supplier__empty bb-supplier__empty--workspace"><span aria-hidden="true">!</span><h2>' +
      esc(title) +
      "</h2><p>" +
      esc(help) +
      "</p>" +
      (actionHtml || "") +
      "</div>";
    detailRoot.removeAttribute("aria-busy");
  }

  function resetWorkspaceState() {
    workspace.classList.remove("is-state");
    queueRoot.hidden = false;
  }

  function previewQueueMetadata() {
    ["action", "progress", "waiting", "history"].forEach(function (bucket) {
      queueCounts[bucket] = orders.filter(function (order) {
        return bucketFor(order) === bucket;
      }).length;
    });
    queueCounts.overdue = orders.filter(function (order) {
      return order.urgency === "overdue" && bucketFor(order) !== "history";
    }).length;
    queueCounts.due_soon = orders.filter(function (order) {
      return order.urgency === "due_soon" && bucketFor(order) !== "history";
    }).length;
    pagination = {
      page: 1,
      page_size: pageSize,
      total: filteredOrders().length,
      page_count: 1,
    };
    statusFacets = [];
    generatedAt = new Date().toISOString();
  }

  function listUrl() {
    var url = new URL(cfg.endpoint, window.location.origin);
    url.searchParams.set("bucket", activeBucket);
    url.searchParams.set("sort", sort.value || "newest");
    url.searchParams.set("page", page);
    url.searchParams.set("page_size", pageSize);
    if (status.value) url.searchParams.set("status", status.value);
    if (urgency.value) url.searchParams.set("urgency", urgency.value);
    if (String(search.value || "").trim())
      url.searchParams.set("q", String(search.value).trim());
    return url.pathname + url.search;
  }

  function syncFilterUrl() {
    var url = new URL(window.location.href);
    ["bucket", "status", "urgency", "sort", "page", "page_size", "q"].forEach(
      function (key) {
        url.searchParams.delete(key);
      },
    );
    url.searchParams.set("bucket", activeBucket);
    if (status.value) url.searchParams.set("status", status.value);
    if (urgency.value) url.searchParams.set("urgency", urgency.value);
    if (String(search.value || "").trim())
      url.searchParams.set("q", String(search.value).trim());
    if (sort.value !== "newest") url.searchParams.set("sort", sort.value);
    if (page > 1) url.searchParams.set("page", page);
    if (pageSize !== 25) url.searchParams.set("page_size", pageSize);
    window.history.replaceState(window.history.state || {}, "", url);
  }

  function renderFreshness() {
    if (!lastUpdated) return;
    if (!generatedAt) {
      lastUpdated.textContent = strings.updating;
      return;
    }
    var time = dashboardTime.formatTime
      ? dashboardTime.formatTime(generatedAt, { timeZone: supplierTimeZone })
      : dateTime(generatedAt);
    lastUpdated.textContent = (strings.lastUpdated || "Updated __TIME__")
      .replace("{{ time }}", time)
      .replace("__TIME__", time);
  }

  function applyOrdersData(data, options) {
    options = options || {};
    supplierTimeZone = dashboardTime.normalizeTimeZone
      ? dashboardTime.normalizeTimeZone(data.timezone || supplierTimeZone)
      : data.timezone || supplierTimeZone;
    orders = Array.isArray(data.work_orders) ? data.work_orders : [];
    pagination = data.pagination || {
      page: page,
      page_size: pageSize,
      total: orders.length,
      page_count: 1,
    };
    page = pagination.page;
    pageSize = pagination.page_size;
    queueCounts = data.counts || queueCounts;
    statusFacets =
      data.facets && Array.isArray(data.facets.statuses)
        ? data.facets.statuses
        : [];
    generatedAt = data.generated_at || new Date().toISOString();
    updateQueueCounts();
    updateStatusOptions();
    renderList(false);
    renderFreshness();
    syncFilterUrl();

    var requestedId =
      selectedId ||
      new URLSearchParams(window.location.search).get("work_order");
    var requested = orders.find(function (order) {
      return order.id === requestedId;
    });
    if (requested) {
      if (!dialog.open)
        loadDetail(requested.id, {
          updateHistory: false,
          announce: options.announceDetail,
        });
      if (mobileQuery.matches) openMobileDetail(requested.id, false);
    } else if (
      requestedId &&
      options.allowExternalSelection !== false &&
      !dialog.open
    ) {
      loadDetail(requestedId, {
        updateHistory: false,
        announce: options.announceDetail,
      });
    } else if (
      !options.preserveSelection &&
      !mobileQuery.matches &&
      filteredOrders()[0]
    ) {
      loadDetail(filteredOrders()[0].id, {
        updateHistory: true,
        announce: options.announceDetail,
      });
    } else if (!options.preserveSelection) {
      renderEmptyDetail();
    }
  }

  function loadOrders(options) {
    options = options || {};
    resetWorkspaceState();
    listRoot.setAttribute("aria-busy", "true");
    refreshButton.disabled = true;
    if (!options.silent) renderDetailLoading();
    if (isPreview) {
      if (previewState === "loading") return Promise.resolve();
      if (previewState === "unauthorized") {
        renderWorkspaceState(
          strings.accessRequired,
          strings.accessRequiredHelp,
          '<a class="bb-btn bb-btn--secondary" href="/pages/account?workspace=customer">' +
            esc(strings.backAccount) +
            "</a>",
        );
        return Promise.resolve();
      }
      if (previewState === "error") {
        count.textContent = strings.temporarilyUnavailable;
        listRoot.innerHTML =
          '<div class="bb-supplier__empty"><span aria-hidden="true">!</span><h2>' +
          esc(strings.loadError) +
          "</h2><p>" +
          esc(strings.loadErrorHelp) +
          '</p><button type="button" class="bb-btn bb-btn--secondary" data-supplier-retry>' +
          esc(strings.retry) +
          "</button></div>";
        listRoot.removeAttribute("aria-busy");
        renderEmptyDetail();
        return Promise.resolve();
      }
      orders = previewState === "empty" ? [] : previewOrders();
      previewQueueMetadata();
      updateQueueCounts();
      updateStatusOptions();
      renderList(false);
      renderFreshness();
      refreshButton.disabled = false;
      if (previewState === "default") {
        noticeRoot.innerHTML =
          "<strong>" +
          esc(
            (strings.newUpdates || "__COUNT__ new updates").replace(
              "__COUNT__",
              "2",
            ),
          ) +
          "</strong><span>" +
          esc(strings.notificationHelp) +
          "</span>";
        noticeRoot.hidden = false;
      }
      var requestedId = new URLSearchParams(window.location.search).get(
        "work_order",
      );
      var requested = orders.find(function (order) {
        return order.id === requestedId;
      });
      if (requested) {
        activeBucket = bucketFor(requested);
        setActiveBucket(activeBucket, false);
        loadDetail(requested.id, { updateHistory: false });
        if (mobileQuery.matches) openMobileDetail(requested.id, false);
      } else if (!mobileQuery.matches && filteredOrders()[0]) {
        loadDetail(filteredOrders()[0].id, { updateHistory: false });
      } else {
        renderEmptyDetail();
      }
      return Promise.resolve();
    }
    workspace.classList.add("is-list-loading");
    var requestUrl = listUrl();
    var cachedData = listCache[requestUrl];
    if (cachedData) {
      applyOrdersData(cachedData, {
        preserveSelection: options.preserveSelection,
        allowExternalSelection: options.allowExternalSelection,
        announceDetail: false,
      });
    } else if (!options.preserveList) {
      renderListLoading();
      if (!options.silent) renderDetailLoading();
    }
    if (requestController) requestController.abort();
    requestController = new AbortController();
    listRequestToken += 1;
    var requestToken = listRequestToken;
    return requestJson(requestUrl, {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
      signal: requestController.signal,
    })
      .then(function (data) {
        if (requestToken !== listRequestToken) return;
        listCache[requestUrl] = data;
        applyOrdersData(data, {
          preserveSelection: options.preserveSelection,
          allowExternalSelection: options.allowExternalSelection,
          announceDetail: !cachedData,
        });
      })
      .catch(function (error) {
        if (error.name === "AbortError") return;
        if (requestToken !== listRequestToken) return;
        if (cachedData || options.preserveList) {
          listRoot.removeAttribute("aria-busy");
          announce(strings.loadError);
          return;
        }
        count.textContent = strings.temporarilyUnavailable;
        listRoot.innerHTML =
          '<div class="bb-supplier__empty"><span aria-hidden="true">!</span><h2>' +
          esc(strings.loadError) +
          "</h2><p>" +
          esc(error.message) +
          '</p><button type="button" class="bb-btn bb-btn--secondary" data-supplier-retry>' +
          esc(strings.retry) +
          "</button></div>";
        listRoot.removeAttribute("aria-busy");
        if (!options.silent) renderEmptyDetail();
      })
      .finally(function () {
        if (requestToken === listRequestToken) {
          workspace.classList.remove("is-list-loading");
          refreshButton.disabled = false;
        }
      });
  }

  function authorizeAndLoad() {
    if (isPreview) return loadOrders();
    return requestJson(cfg.meEndpoint, {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (data) {
        if (!data.supplier) throw new Error(strings.accessRequiredHelp);
        return loadOrders();
      })
      .catch(function (error) {
        renderWorkspaceState(
          strings.accessRequired,
          error.message || strings.accessRequiredHelp,
          '<a class="bb-btn bb-btn--secondary" href="/pages/account?workspace=customer">' +
            esc(strings.backAccount) +
            "</a>",
        );
      });
  }

  function loadNotifications() {
    if (!noticeRoot || !cfg.notificationEndpoint || isPreview) return;
    requestJson(cfg.notificationEndpoint, {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (data) {
        notifications = Array.isArray(data.notifications)
          ? data.notifications
          : [];
        renderNotifications();
      })
      .catch(function () {});
  }

  function confirmationField(textValue) {
    return (
      '<label class="bb-supplier__confirm"><input type="checkbox" name="confirmation" required><span>' +
      esc(textValue) +
      "</span></label>"
    );
  }

  function dialogSection(title, content, modifier) {
    return (
      '<section class="bb-supplier__dialog-section' +
      (modifier ? " " + modifier : "") +
      '">' +
      (title ? '<header><h3>' + esc(title) + '</h3></header>' : '') +
      content +
      "</section>"
    );
  }

  function dialogOrderContext(order) {
    var lines = order.lines || [];
    var line = lines[0] || {};
    var quantity = lines.reduce(function (total, item) {
      return total + (Number(item.quantity) || 0);
    }, 0);
    var delivery =
      order.shipping_mode === "direct"
        ? strings.directDelivery
        : strings.officeHandoff;
    return (
      '<section class="bb-supplier__dialog-context" aria-label="' +
      esc(order.shopify_order_name) +
      '"><div class="bb-supplier__dialog-context-product"><div><strong>' +
      esc(line.title || strings.customProduct) +
      "</strong><small>" +
      esc(line.sku || delivery) +
      "</small></div></div><dl><div><dt>" +
      esc(strings.quantity) +
      "</dt><dd>" +
      esc(quantity || "—") +
      "</dd></div><div><dt>" +
      esc(strings.due) +
      "</dt><dd>" +
      esc(date(order.supplier_due_date)) +
      "</dd></div></dl></section>"
    );
  }

  function carrierOptionsHtml() {
    var options = trackingCarriers.options || [
      "UPS",
      "FedEx",
      "USPS",
      "DHL Express",
      "DHL eCommerce",
    ];
    return options
      .map(function (carrier) {
        return (
          '<option value="' + esc(carrier) + '">' + esc(carrier) + "</option>"
        );
      })
      .join("");
  }

  function syncTrackingCarrierFields() {
    var trackingNumber = dialogFields.querySelector('[name="tracking_number"]');
    var carrier = dialogFields.querySelector('[name="tracking_company"]');
    var suggestion = dialogFields.querySelector(
      "[data-supplier-carrier-suggestion]",
    );
    if (!trackingNumber || !carrier) return;

    var detected =
      typeof trackingCarriers.suggest === "function"
        ? trackingCarriers.suggest(trackingNumber.value)
        : "";
    if (detected) carrier.value = detected;
    if (suggestion) {
      suggestion.textContent = detected
        ? String(
            strings.carrierDetected || "Detected carrier: __CARRIER__",
          ).replace("__CARRIER__", detected)
        : strings.carrierHelp;
      suggestion.classList.toggle("is-detected", Boolean(detected));
    }
  }

  noticeRoot.addEventListener("click", function (event) {
    var button =
      event.target.closest &&
      event.target.closest("[data-supplier-notification-order]");
    if (!button) return;
    loadDetail(button.dataset.supplierNotificationOrder).then(function () {
      openMobileDetail(button.dataset.supplierNotificationOrder, true);
    });
  });

  function openAction(action, trigger) {
    if (dialogBusy) return;
    pendingAction = action;
    lastDialogTrigger = trigger || document.activeElement;
    var order = orders.find(function (item) {
      return item.id === selectedId;
    });
    if (!order) return;
    var actionText = actionCopy(action);
    dialog.dataset.action = action;
    dialogKicker.textContent = order.shopify_order_name;
    dialogTitle.textContent = actionText[0];
    dialogDescription.textContent = actionText[1];
    dialogContext.innerHTML = dialogOrderContext(order);
    var fields = "";
    if (action === "decline")
      fields += dialogSection(
        "",
        '<label class="bb-supplier__dialog-field"><span>' +
          esc(strings.reason) +
          '</span><textarea name="reason" required maxlength="1000" rows="5"></textarea></label>',
        "bb-supplier__dialog-section--danger",
      );
    if (action === "submit_proof")
      fields +=
        dialogSection(
          "",
          '<label class="bb-supplier__dialog-field"><span>' +
            esc(strings.proofReason) +
            '</span><textarea name="reason" maxlength="1000" rows="3" placeholder="' +
            esc(strings.proofReasonExample) +
            '"></textarea></label>',
        ) +
        dialogSection(
          "",
          '<label class="bb-supplier__dialog-field bb-supplier__dialog-file"><span>' +
            esc(strings.proofFiles) +
            '</span><input name="proof" type="file" accept="application/pdf,image/png,image/jpeg" required multiple><small>' +
            esc(strings.fileHelp) +
            '</small><span class="bb-supplier__selected-files" data-selected-files></span></label>',
        );
    if (action === "start_production")
      fields +=
        productionPackageDialogHtml(order) +
        dialogSection(
          "",
          confirmationField(
            strings.startFilesConfirmation || strings.startConfirmation,
          ),
          "bb-supplier__dialog-section--confirmation",
        );
    if (action === "submit_fulfillment") {
      fields +=
        dialogSection(
          strings.tracking,
          '<div class="bb-supplier__dialog-field-grid"><label class="bb-supplier__dialog-field"><span>' +
            esc(strings.trackingNumber) +
            '</span><input name="tracking_number" ' +
            "required" +
            ' maxlength="120" autocomplete="off" autocapitalize="characters" spellcheck="false"></label><label class="bb-supplier__dialog-field"><span>' +
            esc(strings.carrierSelect) +
            '</span><select name="tracking_company" data-supplier-carrier ' +
            "required" +
            '><option value="">' +
            esc(strings.selectCarrier) +
            "</option>" +
            carrierOptionsHtml() +
            '</select><small class="bb-supplier__carrier-status" data-supplier-carrier-suggestion role="status">' +
            esc(strings.carrierHelp) +
            "</small></label></div>",
        ) +
        dialogSection(
          "",
          '<label class="bb-supplier__dialog-field bb-supplier__dialog-file"><span>' +
            esc(strings.invoiceFiles) +
            '</span><input name="invoice" type="file" accept="application/pdf,image/png,image/jpeg" required multiple><small>' +
            esc(strings.fileHelp) +
            '</small><span class="bb-supplier__selected-files" data-selected-files></span></label>',
        ) +
        dialogSection(
          strings.qualityCheck,
          confirmationField(strings.qualityConfirmation),
          "bb-supplier__dialog-section--confirmation",
        );
    }
    dialogFields.innerHTML = fields;
    form.reset();
    dialogError.hidden = true;
    dialogProgress.hidden = true;
    submit.disabled = false;
    submit.innerHTML = actionIcon(action) + '<span>' + esc(actionText[2]) + '</span>';
    submit.classList.toggle("bb-btn--danger", action === "decline");
    submit.classList.toggle("bb-btn--primary", action !== "decline");
    if (action === "submit_fulfillment") syncTrackingCarrierFields();
    dialog.showModal();
    var first = dialogFields.querySelector("input, textarea, select");
    if (first) first.focus();
    else submit.focus();
  }

  function validateFiles(files, emptyMessage) {
    var list = Array.prototype.slice.call(files || []);
    if (!list.length) return emptyMessage;
    var allowed = ["application/pdf", "image/png", "image/jpeg"];
    for (var index = 0; index < list.length; index += 1) {
      if (
        allowed.indexOf(list[index].type) === -1 &&
        !/\.(pdf|png|jpe?g)$/i.test(list[index].name || "")
      )
        return strings.invalidFileType;
      if (list[index].size > 25 * 1024 * 1024) return strings.fileTooLarge;
    }
    return "";
  }

  function renderSelectedFiles(input) {
    var target =
      input &&
      input.parentElement &&
      input.parentElement.querySelector("[data-selected-files]");
    if (!target) return;
    var files = Array.prototype.slice.call(input.files || []);
    target.innerHTML = files.length
      ? "<strong>" +
        esc(strings.selectedFiles) +
        "</strong><ul>" +
        files
          .map(function (file) {
            return (
              '<li data-selected-file="' +
              esc(file.name) +
              '"><span>' +
              esc(file.name) +
              " · " +
              esc(Math.max(1, Math.round(file.size / 1024))) +
              " KB</span><em>" +
              esc(strings.ready) +
              "</em></li>"
            );
          })
          .join("") +
        "</ul>"
      : "";
  }

  function setFileUploadStatus(file, message) {
    var rows = Array.prototype.slice.call(
      dialogFields.querySelectorAll("[data-selected-file]"),
    );
    var row = rows.find(function (item) {
      return item.dataset.selectedFile === file.name;
    });
    if (row && row.querySelector("em"))
      row.querySelector("em").textContent = message;
  }

  function uploadFile(order, file, category) {
    setFileUploadStatus(file, strings.uploading);
    return requestJson(
      cfg.endpoint + "/" + encodeURIComponent(order.id) + "/uploads/prepare",
      {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          original_name: file.name,
          media_type: file.type,
          size_bytes: file.size,
          category: category,
        }),
      },
    )
      .then(function (prepared) {
        return fetch(prepared.signedUrl, {
          method: "PUT",
          headers: { "Content-Type": file.type },
          body: file,
        }).then(function (response) {
          if (!response.ok) throw new Error(strings.uploadFailed);
          return prepared;
        });
      })
      .then(function (prepared) {
        return requestJson(
          cfg.endpoint +
            "/" +
            encodeURIComponent(order.id) +
            "/uploads/" +
            encodeURIComponent(prepared.file_id) +
            "/commit",
          {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
            body: "{}",
          },
        ).then(function () {
          setFileUploadStatus(file, strings.uploaded);
          return prepared.file_id;
        });
      })
      .catch(function (error) {
        setFileUploadStatus(file, strings.uploadFailed);
        throw error;
      });
  }

  function simulatePreviewAction(action, input, files) {
    var order = orders.find(function (item) {
      return item.id === selectedId;
    });
    if (!order) return Promise.reject(new Error(strings.detailError));
    var next = {
      accept: "preflight",
      submit_proof: "awaiting_customer_approval",
      start_production: "in_production",
      submit_fulfillment:
        order.shipping_mode === "direct"
          ? "fulfillment_pending"
          : "handed_off_to_office",
      decline: "declined",
    }[action];
    order.state = next || order.state;
    order.version += 1;
    order.allowed_actions =
      {
        preflight: order.proof_required
          ? ["submit_proof"]
          : ["start_production"],
        approved_for_production: ["start_production"],
        in_production: ["submit_fulfillment"],
        quality_check: ["submit_fulfillment"],
        ready_to_ship: ["submit_fulfillment"],
        revision_requested: ["submit_proof"],
      }[order.state] || [];
    order.responsible_party =
      action === "submit_proof"
        ? "customer"
        : action === "submit_fulfillment"
          ? "staff"
          : "supplier";
    if (action === "submit_proof") {
      order.proofs = order.proofs || [];
      order.proofs.unshift({
        version: order.proofs.length + 1,
        status: "customer_review",
        customer_feedback: "",
        files: (files || []).map(function (file, index) {
          return {
            id: "preview-upload-" + index,
            name: file.name,
            media_type: file.type,
          };
        }),
      });
    }
    if (action === "submit_fulfillment") {
      order.tracking_number = input.tracking_number || "";
      order.tracking_company = input.tracking_company || "";
      order.tracking_url = input.tracking_url || "";
      order.invoice_disposition = input.invoice_disposition;
      order.invoice_office = input.invoice_office || "";
    }
    order.events = order.events || [];
    order.events.unshift({
      action: action,
      actor_type: "supplier",
      reason: input.reason || "",
      created_at: new Date().toISOString(),
    });
    updateQueueCounts();
    updateStatusOptions();
    renderDetail(order);
    if (!mobileQuery.matches && bucketFor(order) !== activeBucket) {
      selectedId = "";
      renderList();
    }
    return Promise.resolve();
  }

  function sendAction(action, input) {
    var order = orders.find(function (item) {
      return item.id === selectedId;
    });
    if (!order) return Promise.reject(new Error(strings.detailError));
    return requestJson(
      cfg.endpoint + "/" + encodeURIComponent(order.id) + "/" + action,
      {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Idempotency-Key": idempotencyKey(),
        },
        body: JSON.stringify({
          expected_version: order.version,
          input: input || {},
        }),
      },
    ).then(function (actionResult) {
      clearNavigationCache(order.id);
      return reconcileCompletedAction(order, actionResult);
    });
  }

  function reconcileCompletedAction(order, actionResult) {
    if (typeof workflowModel.reconcileSupplierAction !== "function")
      return {
        moved: false,
        previousBucket: bucketFor(order),
        nextBucket: bucketFor(actionResult || order),
      };

    var result = workflowModel.reconcileSupplierAction({
      orders: orders,
      counts: queueCounts,
      activeBucket: activeBucket,
      selectedId: selectedId,
      actionResult: actionResult,
    });
    orders = result.orders;
    queueCounts = result.counts;
    selectedId = result.selectedId;

    if (result.moved && result.previousBucket === activeBucket) {
      pagination.total = Math.max(0, Number(pagination.total || 0) - 1);
      pagination.page_count = Math.max(
        1,
        Math.ceil(pagination.total / Math.max(1, pagination.page_size)),
      );
    }

    updateQueueCounts();
    updateStatusOptions();

    if (result.nextBucket !== activeBucket) {
      currentOrder = null;
      replaceWorkOrderInUrl("", "replaceState");
      renderList(false);
      if (mobileQuery.matches) {
        renderEmptyDetail();
        closeMobileDetail(false);
      } else if (orders[0]) {
        replaceWorkOrderInUrl(orders[0].id, "replaceState");
        renderDetailSummary(orders[0]);
      } else {
        renderEmptyDetail();
      }
    } else {
      currentOrder = result.updatedOrder;
      detailCache[result.updatedOrder.id] = result.updatedOrder;
      renderDetail(result.updatedOrder, { announce: false });
    }

    return result;
  }

  function refreshAfterCompletedAction() {
    return loadOrders({
      silent: true,
      preserveList: true,
      preserveSelection: Boolean(selectedId),
      allowExternalSelection: false,
    });
  }

  function setDialogBusy(isBusy, progressText) {
    dialogBusy = isBusy;
    setPromptBusy(submit, isBusy);
    dialog.querySelectorAll("[data-supplier-dialog-close]").forEach(function (button) {
      button.disabled = isBusy;
    });
    dialogFields.querySelectorAll("input, textarea, select").forEach(function (field) {
      field.disabled = isBusy;
    });
    dialogProgress.textContent = progressText || "";
    dialogProgress.hidden = !progressText;
  }

  function setPromptBusy(button, busy) {
    if (!button) return;
    button.classList.add("bb-prompt-busy");
    button.disabled = busy;
    if (busy) button.setAttribute("aria-busy", "true");
    else button.removeAttribute("aria-busy");
  }

  function setActiveBucket(bucket, announceChange) {
    activeBucket = bucket;
    page = 1;
    root.querySelectorAll("[data-supplier-bucket]").forEach(function (button) {
      var selected = button.dataset.supplierBucket === bucket;
      button.setAttribute("aria-selected", selected ? "true" : "false");
      button.tabIndex = selected ? 0 : -1;
      if (selected) listRoot.setAttribute("aria-labelledby", button.id);
    });
    status.value = "";
    if (isPreview) {
      previewQueueMetadata();
      updateStatusOptions();
      renderList();
    } else {
      if (detailRequestController) detailRequestController.abort();
      detailRequestToken += 1;
      detailRequestId = "";
      detailRequestPromise = null;
      selectedId = "";
      currentOrder = null;
      replaceWorkOrderInUrl("", "replaceState");
      syncFilterUrl();
      loadOrders({
        preserveSelection: false,
        allowExternalSelection: false,
      });
    }
    if (announceChange !== false) announce(strings.queueUpdated);
  }

  function resetFilters() {
    search.value = "";
    status.value = "";
    urgency.value = "";
    sort.value = "newest";
    updateFilterCount();
    page = 1;
    if (isPreview) {
      previewQueueMetadata();
      renderList();
    } else loadOrders({ preserveSelection: false });
    announce(strings.queueUpdated);
  }

  listRoot.addEventListener("click", function (event) {
    var item =
      event.target.closest && event.target.closest("[data-supplier-order]");
    if (item) {
      if (mobileQuery.matches)
        openMobileDetail(item.dataset.supplierOrder, true);
      loadDetail(item.dataset.supplierOrder);
      return;
    }
    var retry =
      event.target.closest && event.target.closest("[data-supplier-retry]");
    if (retry) {
      if (isPreview) previewState = "default";
      authorizeAndLoad();
      return;
    }
    if (
      event.target.closest &&
      event.target.closest("[data-supplier-clear-inline]")
    )
      resetFilters();
  });

  detailRoot.addEventListener("click", function (event) {
    var previewLink =
      event.target.closest && event.target.closest('a[href^="#preview-"]');
    if (previewLink) event.preventDefault();
    var button =
      event.target.closest && event.target.closest("[data-supplier-action]");
    if (button) openAction(button.dataset.supplierAction, button);
    if (event.target.closest && event.target.closest("[data-supplier-print]")) {
      preparePrintTicket();
      window.requestAnimationFrame(function () {
        window.print();
      });
    }
  });

  detailRoot.addEventListener(
    "error",
    function (event) {
      var image = event.target;
      if (
        !image ||
        !image.matches ||
        !image.matches("[data-supplier-item-image]")
      )
        return;
      if (thumbnails.advanceImage && thumbnails.advanceImage(image)) return;
      var media = image.closest(".bb-supplier__item-media");
      if (!media) return;
      if (image.getAttribute("data-image-optional") === "true") {
        media.remove();
        return;
      }
      media.setAttribute("aria-hidden", "true");
      media.innerHTML = itemMediaIconHtml();
    },
    true,
  );

  window.addEventListener("beforeprint", preparePrintTicket);
  window.addEventListener("afterprint", removePrintTicket);

  root.querySelectorAll("[data-supplier-bucket]").forEach(function (button) {
    button.addEventListener("click", function () {
      setActiveBucket(button.dataset.supplierBucket);
    });
    button.addEventListener("keydown", function (event) {
      var tabs = Array.prototype.slice.call(
        root.querySelectorAll("[data-supplier-bucket]"),
      );
      var index = tabs.indexOf(button);
      var nextIndex = index;
      switch (event.key) {
        case "ArrowRight":
        case "ArrowDown":
          nextIndex = (index + 1) % tabs.length;
          break;
        case "ArrowLeft":
        case "ArrowUp":
          nextIndex = (index - 1 + tabs.length) % tabs.length;
          break;
        case "Home":
          nextIndex = 0;
          break;
        case "End":
          nextIndex = tabs.length - 1;
          break;
        default:
          return;
      }
      event.preventDefault();
      tabs[nextIndex].focus();
      setActiveBucket(tabs[nextIndex].dataset.supplierBucket);
    });
  });

  function updateFilterCount() {
    var active = Number(Boolean(status.value)) + Number(Boolean(urgency.value));
    filterCount.textContent = String(active);
    filterCount.hidden = active === 0;
    filterToggle.classList.toggle("has-active-filters", active > 0);
  }

  function setFilterPanel(open) {
    filterPanel.hidden = !open;
    filterToggle.setAttribute("aria-expanded", open ? "true" : "false");
  }

  filterToggle.addEventListener("click", function () {
    setFilterPanel(filterToggle.getAttribute("aria-expanded") !== "true");
  });
  document.addEventListener("click", function (event) {
    if (
      filterPanel.hidden ||
      filterPanel.contains(event.target) ||
      filterToggle.contains(event.target)
    )
      return;
    setFilterPanel(false);
  });
  filterPanel.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    setFilterPanel(false);
    filterToggle.focus();
  });

  search.addEventListener("input", function () {
    window.clearTimeout(searchTimer);
    searchTimer = window.setTimeout(function () {
      page = 1;
      if (isPreview) {
        previewQueueMetadata();
        renderList();
      } else loadOrders({ preserveSelection: false });
    }, 300);
  });
  status.addEventListener("change", function () {
    page = 1;
    updateFilterCount();
    if (isPreview) renderList();
    else loadOrders({ preserveSelection: false });
  });
  urgency.addEventListener("change", function () {
    page = 1;
    updateFilterCount();
    if (isPreview) {
      previewQueueMetadata();
      renderList();
    } else loadOrders({ preserveSelection: false });
  });
  sort.addEventListener("change", function () {
    page = 1;
    if (isPreview) renderList();
    else loadOrders({ preserveSelection: true });
  });
  clearFilters.addEventListener("click", resetFilters);
  refreshButton.addEventListener("click", function () {
    loadOrders({ silent: true, preserveSelection: true });
    loadNotifications();
  });
  previousPage.addEventListener("click", function () {
    if (page > 1) {
      page -= 1;
      loadOrders({ preserveSelection: false });
    }
  });
  nextPage.addEventListener("click", function () {
    if (page < pagination.page_count) {
      page += 1;
      loadOrders({ preserveSelection: false });
    }
  });
  pageSizeControl.addEventListener("change", function () {
    pageSize = Number(pageSizeControl.value) === 50 ? 50 : 25;
    page = 1;
    loadOrders({ preserveSelection: false });
  });

  backButton.addEventListener("click", function () {
    if (window.history.state && window.history.state.supplierDetail)
      window.history.back();
    else closeMobileDetail(true);
  });

  window.addEventListener("popstate", function () {
    if (!mobileQuery.matches) return;
    var id = new URLSearchParams(window.location.search).get("work_order");
    if (!id) {
      closeMobileDetail(false);
      return;
    }
    var order = orders.find(function (item) {
      return item.id === id;
    });
    if (order) {
      if (bucketFor(order) !== activeBucket)
        setActiveBucket(bucketFor(order), false);
      loadDetail(id, { updateHistory: false });
      openMobileDetail(id, false);
    }
  });

  mobileQuery.addEventListener("change", function (event) {
    if (!event.matches) {
      root.classList.remove("is-mobile-detail");
      if (!selectedId && filteredOrders()[0])
        loadDetail(filteredOrders()[0].id, { updateHistory: false });
    } else if (!new URLSearchParams(window.location.search).get("work_order")) {
      closeMobileDetail(false);
    }
  });

  root
    .querySelectorAll("[data-supplier-dialog-close]")
    .forEach(function (button) {
      button.addEventListener("click", function () {
        if (dialogBusy) return;
        dialog.close();
      });
    });

  dialog.addEventListener("cancel", function (event) {
    if (dialogBusy) event.preventDefault();
  });

  dialog.addEventListener("close", function () {
    if (lastDialogTrigger && document.contains(lastDialogTrigger))
      lastDialogTrigger.focus();
  });

  dialogFields.addEventListener("change", function (event) {
    if (event.target.type === "file") renderSelectedFiles(event.target);
    if (event.target.name === "tracking_company") {
      syncTrackingCarrierFields();
    }
  });

  dialogFields.addEventListener("input", function (event) {
    if (event.target.name === "tracking_number") syncTrackingCarrierFields();
  });

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    if (dialogBusy) return;
    if (!form.reportValidity()) return;
    var order = orders.find(function (item) {
      return item.id === selectedId;
    });
    var data = new FormData(form);
    var input = {};
    var selectedFiles = [];
    var validationError = "";
    ["reason", "tracking_number", "tracking_company"].forEach(function (key) {
      var value = String(data.get(key) || "").trim();
      if (value) input[key] = value;
    });
    if (pendingAction === "submit_fulfillment") {
      input.tracking_company =
        typeof trackingCarriers.normalize === "function"
          ? trackingCarriers.normalize(input.tracking_company)
          : input.tracking_company;
      if (!input.tracking_company) validationError = strings.carrierRequired;
    }
    if (
      pendingAction === "submit_fulfillment" &&
      form.elements.confirmation &&
      form.elements.confirmation.checked
    )
      input.quality_confirmed = true;
    var fileValidationError = "";
    if (pendingAction === "submit_proof") {
      selectedFiles = Array.prototype.slice.call(
        form.elements.proof.files || [],
      );
      fileValidationError = validateFiles(selectedFiles, strings.chooseProof);
    } else if (pendingAction === "submit_fulfillment") {
      input.invoice_disposition = "uploaded";
      selectedFiles = Array.prototype.slice.call(
        form.elements.invoice.files || [],
      );
      fileValidationError = validateFiles(selectedFiles, strings.chooseInvoice);
    }
    if (!validationError) validationError = fileValidationError;
    if (validationError) {
      dialogError.textContent = validationError;
      dialogError.hidden = false;
      dialogError.focus();
      return;
    }
    dialogError.hidden = true;
    setDialogBusy(
      true,
      selectedFiles.length ? strings.uploading : strings.saving,
    );
    var operation;
    if (isPreview) {
      operation = simulatePreviewAction(pendingAction, input, selectedFiles);
    } else if (pendingAction === "submit_proof") {
      operation = Promise.all(
        selectedFiles.map(function (file) {
          return uploadFile(order, file, "supplier_proof");
        }),
      ).then(function (ids) {
        input.file_ids = ids;
        return sendAction(pendingAction, input);
      });
    } else if (pendingAction === "submit_fulfillment") {
      operation = Promise.all(
        selectedFiles.map(function (file) {
          return uploadFile(order, file, "invoice");
        }),
      ).then(function (ids) {
        input.invoice_file_ids = ids;
        return sendAction(pendingAction, input);
      });
    } else {
      operation = sendAction(pendingAction, input);
    }
    operation
      .then(function () {
        setDialogBusy(false, "");
        dialog.close();
        announce(strings.updated);
        if (window.BBToast)
          window.BBToast.show({
            variant: "success",
            title: strings.updated,
            message: strings.updatedHelp,
          });
        if (!isPreview) refreshAfterCompletedAction();
      })
      .catch(function (error) {
        dialogError.innerHTML =
          esc(error.message) +
          (error.status === 409
            ? ' <button type="button" data-supplier-conflict-reload>' +
              esc(strings.conflictReload) +
              "</button>"
            : "");
        dialogError.hidden = false;
        dialogError.focus();
      })
      .finally(function () {
        setDialogBusy(false, "");
      });
  });

  dialogError.addEventListener("click", function (event) {
    if (
      !event.target.closest ||
      !event.target.closest("[data-supplier-conflict-reload]")
    )
      return;
    dialog.close();
    loadOrders({ silent: true, preserveSelection: true });
  });

  window.setInterval(function () {
    if (document.hidden || dialog.open) return;
    loadOrders({ silent: true, preserveSelection: true });
    loadNotifications();
  }, POLL_INTERVAL);

  document.addEventListener("visibilitychange", function () {
    if (!document.hidden && !dialog.open)
      loadOrders({ silent: true, preserveSelection: true });
  });

  var initialParams = new URLSearchParams(window.location.search);
  if (
    ["action", "progress", "waiting", "history"].indexOf(
      initialParams.get("bucket"),
    ) !== -1
  )
    activeBucket = initialParams.get("bucket");
  search.value = initialParams.get("q") || "";
  if (initialParams.get("status")) {
    status.insertAdjacentHTML(
      "beforeend",
      '<option value="' +
        esc(initialParams.get("status")) +
        '">' +
        esc(stateLabel(initialParams.get("status"))) +
        "</option>",
    );
    status.value = initialParams.get("status");
  }
  urgency.value = initialParams.get("urgency") || "";
  sort.value =
    ["newest", "priority", "due_asc", "updated_desc", "order_desc"].indexOf(
      initialParams.get("sort"),
    ) !== -1
      ? initialParams.get("sort")
      : "newest";
  page = Math.max(1, Number(initialParams.get("page")) || 1);
  pageSize = Number(initialParams.get("page_size")) === 50 ? 50 : 25;
  pageSizeControl.value = String(pageSize);
  root.querySelectorAll("[data-supplier-bucket]").forEach(function (button) {
    var selected = button.dataset.supplierBucket === activeBucket;
    button.setAttribute("aria-selected", selected ? "true" : "false");
    button.tabIndex = selected ? 0 : -1;
    if (selected) listRoot.setAttribute("aria-labelledby", button.id);
  });
  updateFilterCount();

  authorizeAndLoad();
  loadNotifications();
})();
